import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

interface TCallNowApiResponse {
  data: string;
  statusCode: number;
  status: string;
  message: string;
}
export const callNowApiCall = async (
  dealerId: string,
  mobileNumber: string,
  qrPageType?: string
): Promise<IResponse<TCallNowApiResponse> | undefined> => {
  if (!dealerId) {
    return;
  }
  try {
    const response = await encryptedRequest<TCallNowApiResponse>({
      method: "POST",
      url: API_PATHS.callNow,
      data: {
        dealerId: dealerId,
        mobileNo: mobileNumber,
        qrProductCategory: qrPageType,
      },
    });
    return response;
  } catch (error) {
    switch ((error as IResponse<TCallNowApiResponse>)?.statusCode) {
      case 91:
        console.error("Error in API response", error);
        break;
      case 92:
        console.error(
          "Error in API response - Something went wrong while calling exotel api",
          error
        );
        break;
      case 93:
        console.error("Error in API response - FOS Number not found", error);
        break;
    }
    return error as IResponse<TCallNowApiResponse>;
  }
};
